import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    error: '',
    isChecked: true,
    isModalOpen: false,
    isInfoModalOpen: false
};

const kycSlice = createSlice({
    name: 'kyc',
    initialState,
    reducers: {
        setError: (state, action) => {
            state.error = action.payload;
        },
        toggleChecked: (state) => {
            state.isChecked = !state.isChecked;
        },
        openModal: (state) => {
            state.isModalOpen = true;
        },
        closeModal: (state) => {
            state.isModalOpen = false;
            state.error = ''
        },
        openInfoModal: (state) => {
            state.isInfoModalOpen = true;
        },
        closeInfoModal: (state) => {
            state.isInfoModalOpen = false;
        }
    }
});

export const {
    setError,
    toggleChecked,
    openModal,
    closeModal,
    openInfoModal,
    closeInfoModal
} = kycSlice.actions;
export default kycSlice.reducer;
